if (!customElements.get('kik-modal-dialog')) {
    class KikModalDialog extends HTMLElement {
        constructor() {
            super();
            this.querySelector('[id^="kikModalClose-"]').addEventListener('click', this.hide.bind(this, false));
            
            this.addEventListener('keyup', (event) => {
                if (event.code.toUpperCase() === 'ESCAPE') this.hide();
            });

            if (this.classList.contains('media-modal')) {
                this.addEventListener('pointerup', (event) => {
                    if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
                });
            }else {
                this.addEventListener('click', (event) => {
                    if (event.target === this) this.hide();
                });
            }
        }
        
        connectedCallback() {
            if (this.moved) return;
            this.moved = true;
            document.body.appendChild(this);
        }
        
        show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        document.body.setAttribute('overflow-hidden', '');
        // document.documentElement.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        KikTheme.util.trapFocus(this, this.querySelector('[role="dialog"]'));
        KikTheme.util.pauseAllMedia();
        }
        
        hide() {
            document.body.classList.remove('overflow-hidden');
            document.body.removeAttribute('overflow-hidden');
            // document.documentElement.classList.remove('overflow-hidden');
            document.documentElement.dispatchEvent(new CustomEvent('kik-modal:closed'));
            this.removeAttribute('open');
            KikTheme.util.removeTrapFocus(this.openedBy);
            KikTheme.util.pauseAllMedia();
        }
    }
    customElements.define('kik-modal-dialog', KikModalDialog);
}

if (!customElements.get('kik-modal-opener')) {
class KikModalOpener extends HTMLElement {
  constructor() {
      super();
  
      const button = this.querySelector('button') || this.querySelector('.kik-modal-opener-button');
  
      if (!button) return;
          button.addEventListener('click', (e) => {
              e.preventDefault();
              const modal = document.querySelector(this.getAttribute('data-modal'));
              if (modal) modal.show(button);
      });
  }
}
customElements.define('kik-modal-opener', KikModalOpener);
}